<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>


        <div class="container-fluid mt--7">
            <div class="row">


                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase">My WCEA Learning</h3>
                                </div>
                                <div class="col-4 text-right">
                                    <a 
                                        href="/learning/start" 
                                        class="btn btn-sm btn-danger"
                                        v-if="showBackButton"
                                    >
                                        <i class="fa fa-arrow-left"></i> 
                                        Back
                                    </a>
                                </div>
                            </div>
                        </div>


                        <!-- import the start learning page -->
                        <WceaStartPage 
                            v-if="code == 'start'"
                        />

                        <!-- import the WCEA certifcates page -->
                        <WceaCertificates
                            v-if="code == 'certificates'"
                        />

                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import WceaStartPage from './WceaStartPage.vue'
    import WceaCertificates from './WceaCertificates.vue'

    export default {
        components: {
            WceaStartPage,
            WceaCertificates
        },
        name: 'Learning',
        data() {
            return {
                code: this.$route.params.code
            }
        },
        computed: {
            showBackButton() {
                return (this.$route.params.code != 'start');
            }
        }
    };
</script>
